export default __webpack_public_path__ + "static/media/prestashop-logo.4f51000f.png";